import { render, staticRenderFns } from "./ClinicalCaseCard.vue?vue&type=template&id=ae1eba34&"
import script from "./ClinicalCaseCard.vue?vue&type=script&lang=js&"
export * from "./ClinicalCaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports